import { useCarePlanDownloads } from '@views/pages/Downloads/hooks/useCarePlanDownloads.ts';
import { IDownloadsTableEntry } from '@views/pages/Downloads/hooks';
import { FC } from 'react';
import { DownloadsTable } from '@views/pages/Downloads/components/DownloadsTable.tsx';

interface CarePlanDownloadsProps {
  handleCloseDeleteModal: () => void;
  setIsDeleteButtonDisabled: (isDeleteButtonDisabled: boolean) => void;
  currentDownloadItem: IDownloadsTableEntry | null;
  setSelectedItems: (selectedItems: IDownloadsTableEntry[]) => void;
  selectedItems: IDownloadsTableEntry[];
  isMultipleDownloads: boolean;
}

export const CarePlanDownloads: FC<CarePlanDownloadsProps> = ({
  handleCloseDeleteModal,
  setIsDeleteButtonDisabled,
  currentDownloadItem,
  setSelectedItems,
  isMultipleDownloads,
  selectedItems,
}) => {
  const {
    filters,
    onPageIndexChange,
    onPageSizeChange,
    onSearchChange,
    entries,
    setRowsSelection,
    isLoading,
    handleDownload,
    reportsCurrentDownloadItem,
    handleCancel,
    handleRetry,
    totalCount,
    isDeleting,
  } = useCarePlanDownloads({
    handleCloseDeleteModal,
    setIsDeleteButtonDisabled,
    setSelectedItems,
    selectedItems,
  });

  return (
    <DownloadsTable
      rows={entries}
      filters={filters}
      loading={isLoading}
      totalCount={totalCount}
      onPageIndexChange={onPageIndexChange}
      onPageSizeChange={onPageSizeChange}
      onSearchChange={onSearchChange}
      setRowsSelection={setRowsSelection}
      handleDownload={handleDownload}
      currentDownloadItem={reportsCurrentDownloadItem || currentDownloadItem}
      handleCancel={handleCancel}
      handleRetry={handleRetry}
      isDeleting={isDeleting}
      isMultipleDownloads={isMultipleDownloads}
    />
  );
};
